/**
 * CMSD static header name.
 *
 *
 * @beta
 */
export const CMSD_STATIC = 'CMSD-Static'
